import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { BatchBrandResponse, Brand, BrandDtoResponse, BrandErrorResponseEnum, BrandListFilter, CreateBrandResponse } from '../../../../models/brand';


@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(private readonly _http: HttpClient) { }
  list(filter: BrandListFilter & { actualSearch?: string }): Observable<BrandDtoResponse> {
    const { storeId, page = 1, size = 10, name, status, keywords, actualSearch, sort } = filter;

    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('name', name ?? '');

    const valueMap: Record<string, string | undefined> = {
      name,
      status,
      keywords
    };

    let selectedValue = valueMap[actualSearch || '']?.trim();

    if (actualSearch === 'status' && selectedValue) {
      const normalized = selectedValue.toLowerCase();
      if (normalized === 'activa') selectedValue = 'ACTIVE';
      else if (normalized === 'inactiva') selectedValue = 'INACTIVE';
    }

    if (selectedValue) {
      params = params.set(actualSearch!, selectedValue);
    }
    if (sort && sort.length > 0) {
      sort.forEach(s => {
        params = params.append('sort', s);
      });
    }
    params= params.set('_t', new Date().getTime().toString());
    return this._http.get<BrandDtoResponse>(
      `${environment.url}/management/brand/v2/store/${storeId}`,
      { params }
    );
  }

  get(storeId: string, id: string): Observable<Brand> {
    const url = `${environment.url}/management/brand/v2/store/${storeId}/${id}`;
    const timestamp = new Date().getTime().toString();
    let params = new HttpParams().set('_t', timestamp);
    return this._http.get<Brand>(url, { params: params });
  }


  update(brand: Brand, storeId: string, id: string): Observable<void> {
    const url = `${environment.url}/management/brand/v2/store/${storeId}/${id}`;
    return this._http.put<void>(url, brand);
  }

  create(brand: Brand, storeId: string): Observable<CreateBrandResponse> {
    const url = `${environment.url}/management/brand/v2/store/${storeId}`;
    return this._http.post<CreateBrandResponse>(url, brand);
  }

  upload(storeId: string, file: FormData): Observable<BatchBrandResponse> {
    return this._http.post<BatchBrandResponse>(
      `${environment.url}/management/brand/v2/store/${storeId}/upload`,
      file
    );
  }

  updateFile(storeId: string, file: FormData): Observable<BatchBrandResponse> {
    return this._http.post<BatchBrandResponse>(
      `${environment.url}/management/brand/v2/store/${storeId}/upload/update`,
      file
    );
  }

  disable(storeId: string, brandsIds: string[]): Observable<void> {
    return this._http.put<void>(`${environment.url}/management/brand/v2/store/${storeId}/disable-brands`, brandsIds)
  }

  enable(storeId: string, brandsIds: string[]): Observable<void> {
    return this._http.put<void>(`${environment.url}/management/brand/v2/store/${storeId}/enable-brands`, brandsIds)
  }

  disableBrand(storeId: string, brandId: string): Observable<void> {
   const url = `${environment.url}/management/brand/v2/store/${storeId}/${brandId}/disable`;
  return this._http.post<void>(url, {});
 }

  enableBrand(storeId: string, brandId: string): Observable<void> {
    const url = `${environment.url}/management/brand/v2/store/${storeId}/${brandId}/enable`;
  return this._http.post<void>(url, {});
 }

  brandErrorHandler(e: HttpErrorResponse, forcedResponse?: BrandErrorResponseEnum): string {
    if (e.status === 400) return e.error.detail;
    if (forcedResponse) return forcedResponse;

    const errorCode = e.error.properties?.code as keyof typeof BrandErrorResponseEnum;
    const isConflict = e.status === 409 && e.error.title === 'Conflict';

    if (isConflict) {
      if (errorCode === 'BRAND_PERMALINK_ALREADY_TAKEN') return BrandErrorResponseEnum.BRAND_PERMALINK_ALREADY_TAKEN;
      if (errorCode === 'BRAND_NAME_ALREADY_EXISTS') return BrandErrorResponseEnum.BRAND_NAME_ALREADY_EXISTS;
      if (errorCode === 'BRAND_HAS_ASSOCIATED_PRODUCTS') return BrandErrorResponseEnum.BRAND_HAS_ASSOCIATED_PRODUCTS;
      const detail = e.error.detail?.toLowerCase() || '';
      if (detail.includes('permalink')) return BrandErrorResponseEnum.BRAND_PERMALINK_ALREADY_TAKEN;
      if (detail.includes('duplicate key') && detail.includes('name')) return BrandErrorResponseEnum.BRAND_NAME_ALREADY_EXISTS;
    }

    return BrandErrorResponseEnum[errorCode] || BrandErrorResponseEnum.DEFAULT;
  }
  delete(storeId: string, id: string): Observable<void> {
    const url = `${environment.url}/management/brand/v2/store/${storeId}/${id}`;
    return this._http.delete<void>(url);
  }
}